const translations = {
    "regionMap": "{{region}} {{regionType}} map with the administrative boundaries. Service allows creating customized maps with user-defined locations or selected Service or Leisure amenities. Customized maps can be used outside of our service (e.g. by embedding them in third party websites or sharing them via email or internet messenger).",
    "regionMap.regionType.region": "region",
    "regionMap.regionType.city": "locality"
};

export default translations;